// The extension, as a short label for the document column.
//
// The colour-coded blocks a file manager uses are loud at one per row, so this is a label and
// the type is carried by the word. Falls back to the content type's subtype when a filename has
// no extension, and to "FILE" when there is nothing to go on.
const CONTENT_TYPE_LABELS = {
  'application/pdf': 'PDF',
  'text/html': 'HTML',
  'text/plain': 'TXT',
  'text/csv': 'CSV',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/msword': 'DOC',
};

export default function fileTypeLabel(filename, contentType) {
  const byContentType = CONTENT_TYPE_LABELS[contentType];
  if (byContentType) return byContentType;

  const extension = (filename || '').split('.').pop();
  if (extension && extension !== filename && extension.length <= 4) {
    return extension.toUpperCase();
  }

  const subtype = (contentType || '').split('/').pop();
  return subtype ? subtype.slice(0, 4).toUpperCase() : 'FILE';
}
